import React from 'react';

/**
 * PublicScheduleLayout
 * Wrapper de página: fundo suave, container mobile-first centralizado.
 */
export default function PublicScheduleLayout({ children }) {
    return (
        <div className="ps-page">
            <div className="ps-mobile-frame">
                {children}
            </div>
        </div>
    );
}
